import type { ReactNode } from 'react';

export const symbol_format_overline: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M230-780q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h500q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H230Zm51.5 578.5Q200-283 200-400t81.5-198.5Q363-680 480-680t198.5 81.5Q760-517 760-400t-81.5 198.5Q597-120 480-120t-198.5-81.5Zm340-56.76q58.5-58.27 58.5-141.5 0-83.24-58.26-141.74-58.27-58.5-141.5-58.5-83.24 0-141.74 58.26-58.5 58.27-58.5 141.5 0 83.24 58.26 141.74 58.27 58.5 141.5 58.5 83.24 0 141.74-58.26Z"
		/>
	</svg>
);
